var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#111111"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4284 13.628C30.7919 14.5748 30.011 15.3819 29.0857 16.0493C29.0949 16.2283 29.0994 16.4306 29.0994 16.6562C29.0994 17.9097 28.9167 19.1648 28.5512 20.4214C28.1856 21.678 27.6273 22.8808 26.8761 24.0298C26.125 25.1788 25.2302 26.1967 24.1918 27.0835C23.1534 27.9704 21.9052 28.6775 20.4472 29.2048C18.9892 29.7322 17.4267 29.9959 15.7595 29.9959C13.1576 29.9959 10.7616 29.2935 8.57129 27.8887C8.96004 27.9319 9.33288 27.9536 9.68981 27.9536C11.8635 27.9536 13.8049 27.284 15.5141 25.945C14.5006 25.9264 13.593 25.6144 12.7911 25.0091C11.9893 24.4037 11.4375 23.6301 11.1358 22.6884C11.434 22.7452 11.7284 22.7736 12.0189 22.7736C12.4371 22.7736 12.8485 22.7191 13.2533 22.61C12.1717 22.3934 11.2745 21.8547 10.5615 20.9939C9.84862 20.1331 9.49216 19.1397 9.49216 18.0134V17.9554C10.156 18.323 10.8642 18.5185 11.6165 18.542C10.9758 18.1148 10.4678 17.5578 10.0926 16.871C9.71728 16.1841 9.52963 15.4408 9.52963 14.641C9.52963 13.7975 9.74099 13.0121 10.1637 12.2847C11.3399 13.7281 12.7651 14.8816 14.4393 15.7455C16.1136 16.6093 17.9097 17.089 19.8277 17.1847C19.7459 16.8437 19.705 16.488 19.7048 16.1173C19.7048 14.8232 20.1628 13.7183 21.0787 12.8025C21.9946 11.8866 23.0996 11.4287 24.3937 11.4287C25.7485 11.4287 26.8897 11.922 27.8173 12.9087C28.8771 12.6988 29.8694 12.3191 30.7942 11.7696C30.4379 12.891 29.7513 13.756 28.7345 14.3647C29.6691 14.2537 30.567 14.0081 31.4284 13.628H31.4284Z",
    fill: "#FBFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8571,
    height: 18.5672,
    fill: "white",
    transform: "translate(8.57129 11.4287)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.8ae5fb751b597109bd3f233da296a94e.svg";
export { ForwardRef as ReactComponent };